import {Button} from '@material-ui/core';
import CoreRouteConstants from 'Core/CoreRouteConstants';
import React from 'react';
import useRouter from 'use-react-router';

const PasswordRecoveryEmailSent = () => {
  const {history} = useRouter();

  return (
    <div className="password-recovery">
      <div className="password-recovery__form">
        <h1>Email Sent</h1>
        <p className="password-recovery__description">
          A password recovery link has been sent to the email we have on file for your username. Please check your email
          to complete the recovery process.
        </p>
        <Button
          className="btn"
          id="password-recovery-return-to-login-button"
          fullWidth
          onClick={() => history.push(CoreRouteConstants.LOGIN)}
          variant="contained"
          color="primary"
        >
          Return to Login
        </Button>
      </div>
    </div>
  );
};

export default PasswordRecoveryEmailSent;
